<template>
  <input v-debounce:300ms="onDone" type="text" v-model="_value"/>
</template>

<script>
export default {
  props: ['value'],
  data: function(){
    return {
      _value: ''
    }
  },
  created: function(){
    this._value = this.value
  },
  watch: {
    'value' : function(){
      this._value = this.value
    }
  },
  methods: {
    onDone: function(){
      this.$emit('input', this._value)
    }
  }
}
</script>

